import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceTableColumnDirective } from '../resource-table/resource-table-column.directive';
import { EnumOptions } from '@kinet-open-network/shared/data-access/model';

@Component({
  selector: 'kon-enum-column',
  standalone: true,
  imports: [CommonModule, ResourceTableColumnDirective],
  template: ` <p *ngIf="currentLabel()">{{ currentLabel() }}</p> `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnumColumnComponent {
  @Input() label?: string | null = null;
  @Input() options?: Map<string, EnumOptions>;

  valueSignal = signal<unknown | undefined>(undefined);
  @Input() set value(val: unknown | undefined) {
    this.valueSignal.set(val);
  }

  currentOption = computed(() =>
    this.options?.get(this.valueSignal()?.toString() ?? '_default')
  );

  currentLabel = computed(() =>
    this.label ? this.label : this.currentOption()?.label
  );
}
